module.exports = __webpack_public_path__ + "static/media/gift.0e637683.svg";